import {
  useEffect,
  useRef,
  useState
} from 'react'
import { useDispatch } from 'react-redux'
import {
  Box,
  Modal,
  ModalBody,
  Stack,
  useDisclosure
} from '@chakra-ui/react'
import { setMarkerOpenBeforeLogin } from 'store'
import { motion } from 'framer-motion'
import {
  BtnStack,
  BtnStyled,
  ModalContentStyled,
  TextBody,
  TextHeader
} from './styled'

const MotionBox = motion(Box)

export const AskToSignUpModal2 = ({
  dynamicOpenModal,
  setDynamicOpenModal,
  profileItem
}) => {
  const dispatch = useDispatch()
  const [copiedToClipboard, setCopiedToClipboard] = useState(false)
  const copiedToClipboardRef = useRef(copiedToClipboard)
  const initialTimeoutRef = useRef(null)
  const { onOpen, isOpen, onClose } = useDisclosure()

  useEffect(() => {
    copiedToClipboardRef.current = copiedToClipboard

    if (!copiedToClipboard && dynamicOpenModal) {
      setTimeout(() => setDynamicOpenModal(false), 1000)
    }
  }, [copiedToClipboard])

  useEffect(() => {
    if (dynamicOpenModal) {
      initialTimeoutRef.current = setTimeout(() => {
        if (!copiedToClipboardRef.current) {
          setDynamicOpenModal(false)
        }
      }, 4000)
    }
  }, [dynamicOpenModal])

  return (
    <Modal
      isCentered
      trapFocus={false}
      isOpen={dynamicOpenModal}
      onClose={onClose}
    >
      <ModalContentStyled containerProps={{ zIndex: 1410 }}>
        <ModalBody
          margin="0"
          padding="0 10px"
          textAlign="center"
          overflow="hidden"
          maxHeight="65svh"
          overflowY="scroll"
          sx={{
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none'
            }
          }}
        >
          <MotionBox
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            transition={{
              type: 'tween',
              duration: 0.5
            }}
            height="auto"
            margin="20px 0"
          >
            <Stack margin="20px 0" gap="0 !important">
              <TextHeader>Please</TextHeader>
              <TextHeader>sign in/sign up</TextHeader>
              <TextHeader>to interact</TextHeader>
            </Stack>

            <Box
              margin="20px auto 10px auto"
              display="flex"
            >
              <BtnStack margin="20px auto 10px auto">
                <BtnStyled
                  as="button"
                  onClick={() => {
                    setDynamicOpenModal(false)
                    setCopiedToClipboard(false)
                    clearTimeout(initialTimeoutRef.current)
                    dispatch(setMarkerOpenBeforeLogin(true))
                    document.querySelector('.profile-icon').click()
                  }}
                >
                  Sign In
                </BtnStyled>
              </BtnStack>

              <BtnStack margin="20px auto 10px auto">
                <BtnStyled
                  as="button"
                  onClick={() => {
                    if (!copiedToClipboard) {
                      setCopiedToClipboard(true)
                      navigator.clipboard.writeText(window.location.origin + '/?id=' + profileItem?.id)
                      setTimeout(() => setCopiedToClipboard(false), 3000)
                    }
                  }}
                >
                  Save
                </BtnStyled>
              </BtnStack>
            </Box>
          </MotionBox>

          <MotionBox
            initial={{
              scaleY: copiedToClipboard ? 0 : 1,
              margin: copiedToClipboard ? 0 : '20px 0'
            }}
            animate={{
              scaleY: copiedToClipboard ? 1 : 0,
              margin: copiedToClipboard ? '20px 0' : 0,
              ...(!copiedToClipboard && { height: 0 })
            }}
            transition={{
              type: 'tween',
              duration: 0.5
            }}
          >
            <TextBody
              margin="0px auto 20px auto"
              opacity={copiedToClipboard ? 1 : 0}
            >
              Profile saved to clip board
            </TextBody>
          </MotionBox>
        </ModalBody>
      </ModalContentStyled>
    </Modal>
  )
}
